import getKeys from './getKeys';
const dedupeArrayMerge = (query, value) => {
  const dedupedValues = new Set([].concat(query, value));
  return Array.from(dedupedValues);
};
export default function translate() {
  let query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    target = 'lsc'
  } = options;
  return Object.entries(query).reduce((acc, _ref) => {
    let [key, value] = _ref;
    // get all permutations of the parameter key
    const keys = getKeys(key);
    if (keys) {
      // isolate the paramter key that we are targeting
      const {
        [target.toLowerCase()]: targetKey
      } = keys;

      // iterate over all possible versions of that parameter key and
      // merge all permutations and assign to the targeted key
      return Object.values(keys).reduce((mergedParam, paramKey) => {
        // if the original queryset has a value for the key then we need to translate it
        if (query[paramKey] !== undefined) {
          // If there is already an existing value for final target key then
          // we need to merge them as a deduped array
          if (Object.prototype.hasOwnProperty.call(mergedParam, targetKey)) {
            mergedParam[targetKey] = dedupeArrayMerge(mergedParam[targetKey], query[paramKey]);
          } else {
            // If there is not already a value for the final target key then
            // we set the value to be the value of this permutation
            mergedParam[targetKey] = query[paramKey];
          }
        }

        // return all the merged values for each parameter set
        return mergedParam;
      }, acc);
    }

    // if we don't need to translate then just set the original value on the original key
    acc[key] = value;
    return acc;
  }, {});
}